import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";

interface VueForm extends Vue {
    title: string;
}

Vue.use(Vuex);

const VueForm = {
    computed: {
        title: {
            get(this: VueForm) { return this.$store.state.details.title }, // for realestate
        },
        objectTitle: {
            get(this: VueForm) { return this.$store.state.details.objectTitle; }, // for rent object
        },
        isShow: {
            get(this: VueForm) {
                const n = this.$route.name;
                return n === "realestatedetail" || n === "rentsdetail";
            },
        },
    },
} as ComponentOptions<VueForm>;

export { VueForm };



// WEBPACK FOOTER //
// ./src/components/vue-form.ts